// USA
import MENU from "./Layout/menu_en"
import Old from "./old_en"

export const locale = {
  ...MENU,
  ...Old
};
